import { InfoPopover, InfoPopoverProps } from '@adsk/alloy-react-tooltip';
import { forwardRef, FunctionComponent, RefAttributes } from 'react';
import { translate } from '../../../helpers';
import { FormFieldInfoPopover } from '../FormFieldInfoPopover';

export const DueDateInfoPopover: FunctionComponent<
  Omit<InfoPopoverProps, 'message'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => (
  <FormFieldInfoPopover
    {...props}
    ref={ref}
    message={translate('tooltips.dueDate')}
    variant={InfoPopover.VARIANTS.DARK}
    data-testId="DueDateInfoPopover"
  />
));
